<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="add-role-dialog"
  >
    <div class="form-content">
      <role-form
        :form-data="formData"
        ref="outform"
        @submit="submit"
      ></role-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import roleForm from "@/components/sys/roleList/roleForm";
import { queryRoleDetail, updateRole} from "@/api/sys/roleList";

export default {
  name: "editRoleDialog",
  components: {
    roleForm,
  },
  props: {
    roleId:{
      type: Number,
    },
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '编辑',
      formData: {
        roleId: '',
      }
    }
  },
  watch:{
    dialogShow(newValue){
      if(newValue && this.roleId){
        setTimeout(() => {
          this.getUserDetail(this.roleId);
        },200);
      }
    },
  },
  methods: {
    getUserDetail(roleId){
      queryRoleDetail({roleId: roleId}).then((res) => {
        this.formData = res.role;
      })
    },
    beforeClose() {
      this.$emit('close');
      this.formData = {
        roleId: '',
      };
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form,menuIdList) {
      let params = {
        roleId: form.roleId,
        'roleName': form.roleName,
        'remark': form.remark,
        'menuIdList': menuIdList
      }
      updateRole(params).then((data) => {
        if(data && data.code===200){
          this.$message({
            message: '编辑成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message({
            message: data.msg,
            type: 'error'
          });
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style scoped>

</style>
